import React from 'react';
import { profileUri } from 'Consts/clientUris';
import { renderToStaticMarkup } from 'react-dom/server';
import moment from 'moment';

// Gets # of days from creation date for setting task / to do due date
const url = new URL(window.location.href);
const rootUrl = url.origin;

const weekFromNow = () => moment().add(7, 'days').toISOString();

// Generate schema
const generateTaskTopicSchema = () => {
  const schema = [
    {
      category: 'On-Boarding',
      ownerCategory: 'primaryClient',
      name: 'Tell us about yourself',
      priority: 'high',
      description: renderToStaticMarkup(<p>We tailor our planning process around you! The first step in getting started is for you to tell us about yourself. Click <a href={`${rootUrl}${profileUri}`} target="_blank" rel="noopener noreferrer">here</a> to fill out your Personal &amp; Family Information.</p>),
      dueDate: weekFromNow(),
    },
    {
      category: 'On-Boarding',
      ownerCategory: 'primaryClient',
      name: 'Complete Personal Information section on Profile',
      dueDate: weekFromNow(),
    },
    {
      category: 'On-Boarding',
      ownerCategory: 'primaryClient',
      name: 'Upload your Social Security statement',
      priority: 'high',
      description: renderToStaticMarkup(<p>Our money flow tool can only capture what actually hits your bank account. That doesn’t allow us to see all of your Social Security income (and other retirement income sources). Please click the “Add File” button to share all of your retirement income documentation with us.</p>),
      dueDate: weekFromNow(),
    },
    {
      category: 'Cash flow & budgets',
      ownerCategory: 'primaryClient',
      name: 'Upload your pay stub',
      priority: 'high',
      description: renderToStaticMarkup(<p>Our money flow tool can only capture what actually hits your bank account. That doesn’t allow us to see pre-tax earnings and contributions. Please click the <q>Add File</q> button to share all of your paystubs with us.</p>),
      dueDate: weekFromNow(),
    },
    {
      category: 'Cash flow & budgets',
      ownerCategory: 'primaryClient',
      name: 'Link bank accounts',
      dueDate: weekFromNow(),
    },
    {
      category: 'Cash flow & budgets',
      ownerCategory: 'planner',
      name: 'Develop resource allocation proposal',
      dueDate: weekFromNow(),
    },
    {
      category: 'Cash flow & budgets',
      ownerCategory: 'planner',
      name: 'Review tax return to determine optimal withholdings',
      dueDate: weekFromNow(),
    },
    {
      category: 'Debt',
      ownerCategory: 'primaryClient',
      name: 'Upload credit card statement',
      dueDate: weekFromNow(),
    },
    {
      category: 'Debt',
      ownerCategory: 'primaryClient',
      name: 'Upload mortgage statement',
      dueDate: weekFromNow(),
    },
    {
      category: 'Debt',
      ownerCategory: 'primaryClient',
      name: 'Upload HELOC statement',
      dueDate: weekFromNow(),
    },
    {
      category: 'Debt',
      ownerCategory: 'primaryClient',
      name: 'Link debt accounts',
      dueDate: weekFromNow(),
    },
    {
      category: 'Debt',
      ownerCategory: 'planner',
      name: 'Develop debt paydown proposal',
      dueDate: weekFromNow(),
    },
    {
      category: 'Investments',
      ownerCategory: 'primaryClient',
      name: 'Upload investment account statements',
      dueDate: weekFromNow(),
    },
    {
      category: 'Investments',
      ownerCategory: 'primaryClient',
      name: 'Upload 401(k) statement and investment options',
      dueDate: weekFromNow(),
    },
    {
      category: 'Investments',
      ownerCategory: 'primaryClient',
      name: 'Link investment accounts',
      dueDate: weekFromNow(),
    },
    {
      category: 'Investments',
      ownerCategory: 'planner',
      name: 'Develop 401(k) proposal',
      dueDate: weekFromNow(),
    },
    {
      category: 'Investments',
      ownerCategory: 'planner',
      name: 'Develop investment proposal',
      dueDate: weekFromNow(),
    },
    {
      category: 'Investments',
      ownerCategory: 'planner',
      name: 'Reallocate investment account',
      dueDate: weekFromNow(),
    },
    {
      category: 'Investments',
      ownerCategory: 'planner',
      name: 'Review tax loss harvesting strategy',
      dueDate: weekFromNow(),
    },
    {
      category: 'Education',
      ownerCategory: 'primaryClient',
      name: 'Upload 529 plan statement',
      dueDate: weekFromNow(),
    },
    {
      category: 'Employee benefits',
      ownerCategory: 'primaryClient',
      name: 'Upload employee benefit Package',
      dueDate: weekFromNow(),
    },
    {
      category: 'Employee benefits',
      ownerCategory: 'planner',
      name: 'Develop employee benefits proposal',
      dueDate: weekFromNow(),
    },
    {
      category: 'Insurance & risk management',
      ownerCategory: 'primaryClient',
      name: 'Upload homeowner’s insurance documentation',
      dueDate: weekFromNow(),
    },
    {
      category: 'Insurance & risk management',
      ownerCategory: 'primaryClient',
      name: 'Upload life insurance documentation',
      dueDate: weekFromNow(),
    },
    {
      category: 'Insurance & risk management',
      ownerCategory: 'primaryClient',
      name: 'Upload auto insurance documentation',
      dueDate: weekFromNow(),
    },
    {
      category: 'Insurance & risk management',
      ownerCategory: 'primaryClient',
      name: 'Upload renter’s insurance documentation',
      dueDate: weekFromNow(),
    },
    {
      category: 'Insurance & risk management',
      ownerCategory: 'planner',
      name: 'Develop insurance proposal',
      dueDate: weekFromNow(),
    },
  ];

  return schema;
};

export default generateTaskTopicSchema;
